<template>
  <div class="container step">
    <div class="group-container">
      <div class="group" v-for="(row,key) in dataRow" :key="key">
        <div class="content">
            {{row.title}}
        </div><!-- content end sub -->
        <div :class="'checkboxGroup' + ( row.half ? ' half' : '')">
          <div class="item" v-for="rows in row.checkbox" :key="rows.id">
            <input type="radio" @change="onChangeData(rows, row.keys)" :name="'s'+row.keys" :id="rows.id">
            <label :for="rows.id" class="text">
              <span class="checkboxText">{{rows.text}}</span>
              <textarea
              v-model="rows.remark"
              v-if="rows.text == '其他'" name="" placeholder="輸入文字"
              class="textarea" rows="4">
            </textarea>
            </label>
          </div>
        </div><!-- checkbox group end sub -->
      </div><!-- group end sub -->
    </div>
    <template>
      <router-link to="/step4" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step4-2" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'step1-1',
  data () {
    return {
      pageChage: false,
      props: ['result'],
      selectData: {
        'step4-1': {
          id: '',
          text: '',
          remark: ''
        },
        'step4-2': {
          id: '',
          text: '',
          remark: ''
        }
      },
      dataRow: [
        {
          keys: 'step4-1',
          title: '臨床上,處方Cisplatin治療時,您是否會特別評估患者的日常體能狀態(performance status, PS)?',
          half: false,
          checkbox: [
            {
              id: 's1-1',
              text: '會',
              remark: ''
            },
            {
              id: 's1-2',
              text: '不會',
              remark: ''
            },
            {
              id: 's1-3',
              text: '其他',
              remark: ''
            }
          ]
        },
        {
          keys: 'step4-2',
          title: '在臨床上,遇到較差體能狀態的轉移性上泌尿道上皮癌患者,您會採用何種治療選擇?',
          half: false,
          checkbox: [
            {
              id: 's2-1',
              text: 'Cisplatin類化療',
              remark: ''
            },
            {
              id: 's2-2',
              text: '改用carboplatin類化療',
              remark: ''
            },
            {
              id: 's2-3',
              text: '改用免疫療法',
              remark: ''
            },
            {
              id: 's2-4',
              text: '其他',
              remark: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    onChangeData: function ($row, keys) {
      var val = this.selectData
      val[keys] = $row
      // console.log(this.selectData)
      if ((val['step4-1']['id'] !== '') && (val['step4-2']['id'] !== '')) {
        this.$emit('update:result', val)
        this.pageChage = true
      }
    }
  }
}
</script>

<style scoped>
  .container {text-align:center;}
  .container:before,
  .container:after {
    content:"";display:inline-block;
    vertical-align:middle;
    height:100%;width:0px;
  }
  .step .group .content {
    background:#b7798e;
  }
  .step .checkboxGroup .item input[type='radio']:checked + .text:before {
    background:#b7798e;border-color:#b7798e;
  }
  a[class*="btn-"] {
    background:#b7798e;color:white;
  }
</style>



// WEBPACK FOOTER //
// src/components/step4/question.vue